import { LOCALES } from '../../constants/intl';
import { Messages } from '../../types';

import uk from './uk';

interface LocaleMessages {
  readonly [LOCALES.UK]: Messages;
}

const messages: LocaleMessages = { uk };

export default messages;
